import React from "react";
import { Box, IconButton, Divider } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import XIcon from "@mui/icons-material/X";

interface SocialLink {
  icon: React.ReactNode;
  url: string;
  title: string;
}

const SocialLinks: React.FC = () => {
  const socialLinks: SocialLink[] = [
    {
      icon: <LinkedInIcon />,
      url: "https://www.linkedin.com/in/shashi-s-6a5463ab/",
      title: "LinkedIn",
    },
    {
      icon: (
        <Box component="span" sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
          H
        </Box>
      ),
      url: "https://www.hackerrank.com/sharmashashi940",
      title: "HackerRank",
    },
    {
      icon: <WhatsAppIcon />,
      url: "https://wa.me/9779860007757",
      title: "WhatsApp",
    },
    {
      icon: <XIcon />,
      url: "https://twitter.com/_shashisharma",
      title: "Twitter",
    },
    {
      icon: <GitHubIcon />,
      url: "https://github.com/sharmashashi",
      title: "Github",
    },
    {
      icon: <EmailIcon />,
      url: "mailto:hello@shashi-sharma.com.np",
      title: "E-mail",
    },
  ];

  const handleClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "row", md: "column" },
        alignItems: "center",
        gap: 1,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        padding: { xs: "8px 16px", md: "16px 8px" },
        borderRadius: { xs: 2, md: 2 },
      }}
    >
      {/* Line before icons on desktop, after on mobile */}
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          width: 2,
          height: 40,
          backgroundColor: "divider",
        }}
      />

      {socialLinks.map((link, index) => (
        <React.Fragment key={link.title}>
          <IconButton
            onClick={() => handleClick(link.url)}
            title={link.title}
            sx={{
              color: "white",
              "&:hover": {
                color: "primary.main",
                transform: "scale(1.1)",
              },
              transition: "all 0.2s",
            }}
          >
            {link.icon}
          </IconButton>
          {index < socialLinks.length - 1 && (
            <Divider
              orientation={window.innerWidth < 900 ? "vertical" : "horizontal"}
              flexItem
              sx={{
                display: { xs: "block", md: "none" },
                backgroundColor: "divider",
              }}
            />
          )}
        </React.Fragment>
      ))}

      {/* Line after icons on desktop */}
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          width: 2,
          height: 40,
          backgroundColor: "divider",
        }}
      />
    </Box>
  );
};

export default SocialLinks;
